<template>
  <tr>
    <td data-label="Address">
      <strong>
        <router-link :to="{ path: property.uuid, append: true }">
          {{ property.address }}
        </router-link>
      </strong>
    </td>
    <td data-label="Postcode">
      {{ property.postcode }}
    </td>
    <td data-label="Lots">
      {{ property.lots }}
    </td>
    <td data-label="Insurance Company">
      {{ property.insuranceCompany }}
    </td>
    <td data-label="Company">
      <router-link 
        v-if="property.Company"
        :to="'/database-manager/companies/' + property.Company.uuid">
        {{ property.Company.name }}
      </router-link>
    </td>
    <td data-label="Access Instructions">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ property.accessInstructions }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ property.accessInstructions }}
      </span>
    </td>
    <td class="text-center">
      <dropdown 
        :title="'Property Actions'"
        :icon="'fa fa-building'"
        :actions="propertyActions"
        @action="executeAction($event, property)">
      </dropdown>
    </td>
  </tr>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import {
    SET_PROPERTY_ACTIONS,
    ADD_PROPERTY_NOTE,
    SELECT_CONTRACTORS,
    EDIT_PROPERTY,
    DELETE_PROPERTY,
    UPLOAD_PROPERTY_PHOTO
  } from '@/vuex/types'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'PropertyRow',
    components: {
      Dropdown
    },
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      property () {
        if (this.$route.meta.client) {
          this.$store.commit(SET_PROPERTY_ACTIONS)
        }
        return {
          Company: {},
          ...this.object
        }
      },
      ...mapGetters([
        'propertyActions'
      ])
    },
    methods: {
      async executeAction (action, payload) {
        await this[action](payload)
      },
      ...mapActions([
        ADD_PROPERTY_NOTE,
        SELECT_CONTRACTORS,
        EDIT_PROPERTY,
        DELETE_PROPERTY,
        UPLOAD_PROPERTY_PHOTO
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/Property.vue